import { Component, OnInit, ViewChild, Input, ɵConsole } from "@angular/core"; import { Location } from "@angular/common";
import { MenuItem } from 'primeng/api';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { Fournisseur } from 'src/app/entites/fournisseur';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { LocationEntite } from 'src/app/entites/location';
import { TypeLocationEntite } from 'src/app/entites/type-location';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { LocationService } from 'src/app/services/location-service';
import { UniteEntite } from 'src/app/entites/unite';
import { CoutLocationEntite } from 'src/app/entites/cout-location';
import { ETypesLocation } from 'src/app/entites/enums/type-location';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { DocumentEntite } from 'src/app/entites/document';
import { DocumentService } from 'src/app/services/document-service';
import { environment } from 'src/environments/environment';
import { RequeteObtenirDocuments } from 'src/app/services/requetes/requete-obtenir-documents';
import { ContexteService } from 'src/app/services/contexte-service';
import { BaseComponent } from 'src/app/base/base-component';
import { Emplacement } from 'src/app/entites/emplacement';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { AchatService } from 'src/app/services/achat-service';
import { ConfirmerDebutLocationComponent, ResultatConfirmerDebutLocation } from '../../locations/controles/confirmer-debut-location.component';
import { InfoBonLocationComponent, ResultatInfoBonLocation } from '../../locations/controles/info-bon-location.component';
import { ConfirmerFinLocationComponent } from '../../locations/controles/confirmer-fin-location.component';
import { DetailDocumentComponent } from '../../documents/controles/detail-document.component';
import { LigneKmEntite } from 'src/app/entites/mecanique/ligne-km';
import { DepartementEntite } from 'src/app/entites/departement';
import { KmService } from 'src/app/services/km-service';
import { DepartementMecaniqueEntite } from 'src/app/entites/mecanique/departement-mecanique';

@Component({
    templateUrl: './saisie-kms.component.html',
    styleUrls: ['./saisie-heures.component.scss'],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class SaisieKmsComponent extends BaseComponent implements OnInit {

    kmManuelle: LigneKmEntite = {};
    kmsCompletes: LigneKmEntite[] = [];
    kms: LigneKmEntite[] = [];

    dateKms: Date = new Date();

    departements: DepartementMecaniqueEntite[];
    departement: DepartementMecaniqueEntite;
    emplacements: Emplacement[];
    emplacement: Emplacement;

    etape: number = 1;

    menu: MenuItem[];

    submittedManuel: boolean = false;
    submittedListe: boolean = false;

    @ViewChild('inputNumero') inputNumero;
    @ViewChild('inputKms') inputKms;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute, 
		appMain: AppMainComponent, location: Location, 
        private breadcrumbService: BreadcrumbService,
        private kmService: KmService,
        private documentService: DocumentService,
        private locationService: LocationService,
        private fournisseurService: FournisseurService,
        private contexteService: ContexteService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router ) {

        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Saisie des kms' }
        ]);

    }

    ngOnInit() {

        this.verifierAccesPage('heures_saisie');

        this.departements = this.sdb.DepartementsMecanique();
        this.emplacements = this.sdb.Emplacements();

        this.kmService.ObtenirListe().then(res => {
            
            if (res.estUnSucces) {
                this.kmsCompletes = res.valeur;
                this.filtrer();
            }

            this.initialiserMenu();

            this.CompleterChargement();
            
            setTimeout(() => { this.inputNumero.nativeElement.focus(); }, 50);

        });
       
    }

    initialiserMenu() {
        this.menu = [
            {
                label: 'Retour', icon: 'pi pi-fw pi-angle-double-left', command: () => window.history.back()
            }
        ];
    }

    filtrer() {

        this.kms = this.kmsCompletes;
        if (this.departement) {
            this.kms = this.kms.filter(x => x.departementId == this.departement.departementMecaniqueId);
        }
        if (this.emplacement) {
            this.kms = this.kms.filter(x => x.emplacementId == this.emplacement.emplacementId);
        }

    }

    retirerFiltres() {
        this.departement = null;
        this.emplacement = null;
        this.filtrer();
    }

    validerNoItem(){

        const h = this.kms.find(x => x.numero.toLowerCase() == this.kmManuelle.numero.toLowerCase());

        if (h) {

            if (h.indSuiviKms) {

                if (!h.indApprouve) {
                    this.kmManuelle.indItemValide = false;
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'L\'unité a déjà des kms en approbation' });
                    return;
                    }
        
                    this.kmManuelle.itemId = h.itemId;
                    this.kmManuelle.description = h.description;
                    this.kmManuelle.kmsActuelles = h.kmsActuelles;
                    this.kmManuelle.dateKmsActuelles = h.dateKmsActuelles;
                    this.kmManuelle.indApprouve = h.indApprouve;
                    this.kmManuelle.indItemValide = true;
                    this.etape = 2;
                    setTimeout(() => { this.inputKms.nativeElement.focus(); }, 50);
                    
            } else {

                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Les km ne sont pas suivis sur cette unité.' });

            }

            
        } else {
            this.kmManuelle.indItemValide = false;
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Unité introuvable' });
        }

    }

    sauvegarderKmManuelle(){

        console.log(this.kmManuelle);

        this.kmManuelle.dateNouvellesKms = this.dateKms;

        this.kmService.Ajouter({
            employeId: this.profilService.ProfilCourant().employeId,
            lignesKm: [
                this.kmManuelle
            ]
        }).then(res => {
            if (res.estUnSucces) {
                this.kmManuelle = {
                    indItemValide: false
                }
                this.etape = 1;
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Kms sauvegardées.` });
                setTimeout(() => { this.inputNumero.nativeElement.focus(); }, 50);
            }
            else{
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: res.valeur[0].erreur });
            }
        })
    }

    sauvegarderKms() {

        this.kms.forEach(h => {
            h.dateNouvellesKms = this.dateKms;
            h.erreur = null;
        });

        this.kmService.Ajouter({
            employeId: this.profilService.ProfilCourant().employeId,
            lignesKm: this.kms.filter(x => x.kms)
        }).then(res => {
            if (res.estUnSucces) {
                this.kms.forEach(h => {
                    h.kms = null;
                });
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Kms sauvegardées.` });
                setTimeout(() => { this.inputNumero.nativeElement.focus(); }, 50);
            }
            else{
                res.valeur.forEach(l => {
                    if (l.erreur) {
                        var ligneAMettreEnErreur = this.kms.find(x => x.itemId == l.itemId);
                        ligneAMettreEnErreur.erreur = l.erreur;
                    }
                });
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Des erreurs empêchent la sauvegarde des kms.' });
            }
        })

    }

    annuler() {
        this.kmManuelle = {
            indItemValide: false
        }
        this.etape = 1;
        setTimeout(() => { this.inputNumero.nativeElement.focus(); }, 50);
    }

}
